/*eslint no-use-before-define:0 no-plusplus:0 */ //TODO REMOVE THIS
/*global FileList */
var _ = require("ES/lib/lodash");
var radio = require("ES/lib/radio");
var Balboa = require("ES/services/Balboa");
var esUtils = require("ES/utils/esUtils");
var Constants = require("../utils/Constants");
let RadioService = require("ES/lib/react-pubsub-via-radio.js/service");
var ServicesUtils = require("ES/utils/ServicesUtils");
var reloadDisplaylists = require("../utils/reloadDisplaylists");
var AuthedUserSession = require("../utils/AuthedUserSession");

var eventCache = (function () {
  var mutable_cache = {}; //only used internally
  var immutable_cache = {}; //used for reading

  var save = function (event_id, event) {
    if (_.isPlainObject(event)) {
      mutable_cache[event_id] = event;

      immutable_cache[event_id] = _.cloneDeep(event);
      if (_.isFunction(Object.freeze)) {
        Object.freeze(immutable_cache[event_id]);
      }
    } else {
      mutable_cache[event_id] = null;
      immutable_cache[event_id] = null;
    }
  };

  return {
    read: function (event_id) {
      return _.has(immutable_cache, event_id)
        ? immutable_cache[event_id]
        : null;
    },
    save: save,
    extend: function (event_id, extension) {
      if (_.isPlainObject(mutable_cache[event_id])) {
        save(event_id, _.assign(mutable_cache[event_id], extension));
      }
    },
  };
})();

var broadcastEvent = function (event_id) {
  radio("Event").broadcast(eventCache.read(event_id));
};

var EventPoller = (function () {
  var is_currently_polling = {};
  var interval_handle = null;

  var poll = function (event_id) {
    if (
      _.has(is_currently_polling, event_id) &&
      is_currently_polling[event_id]
    ) {
      return; //already pooling
    }
    is_currently_polling[event_id] = true;
    var done = function () {
      is_currently_polling[event_id] = false;
    };
    Balboa.api(
      "/event/lastmodified/" + event_id,
      {},
      function (data) {
        if (!interval_handle) {
          //has the poller stopped?
          return done(); //stop now b/c we stopped polling
        }
        var new_date = esUtils.convertFromISO8601(data.modified_ISO8601);
        var curr_event = eventCache.read(event_id);
        if (
          curr_event &&
          _.isDate(curr_event.modified) &&
          curr_event.modified.getTime() !== new_date.getTime()
        ) {
          Balboa.api(
            "/event/read/" + event_id,
            {},
            function (data) {
              if (!interval_handle) {
                //has the poller stopped?
                return done(); //stop now b/c we stopped polling
              }
              var new_event = esUtils.convertBalboa3EventToJSEvent(
                data.data.event
              );

              var diff = esUtils.deepDiff(eventCache.read(event_id), new_event);
              radio("loadedNewEventVersion_diff").broadcast(
                diff,
                eventCache.read(event_id),
                new_event
              );

              eventCache.save(event_id, new_event);
              broadcastEvent(event_id);
              done();
            },
            function (data) {
              //TODO decide what to do
              done();
            }
          );
        } else {
          done();
        }
      },
      function () {
        done();
      }
    );
  };
  var stop = function () {
    clearInterval(interval_handle);
    interval_handle = null; //so poll knows we're no longer listening
  };
  return {
    start(event_id) {
      if (!(event_id > 0)) {
        return;
      }
      stop();
      interval_handle = setInterval(function () {
        poll(event_id);
      }, 30 * 1000);
    },
    stop,
  };
})();

let getEventChangeSummary = function (old_event, new_event) {
  let changes = {
    status_change: false,
    rep_change: false,
    bureauID_change: false,
    pdrep_change: false,
    status_changed_to_canceled: false,
    status_changed_to_confirmed: false,
    royalty_dependant_item_changed: false,
    company_change: false,
    evaluation_score_changed: false,
    relay_changed: false,
  };
  if (_.isEmpty(old_event) || !_.has(old_event, "status")) {
    return changes;
  }
  if (old_event.status !== new_event.status) {
    changes.status_change = true;
    if (new_event.status === "canceled") {
      changes.status_changed_to_canceled = true;
    }
    if (new_event.status === "confirmed") {
      changes.status_changed_to_confirmed = true;
    }
  }
  if (old_event.pd_rep_id !== new_event.pd_rep_id) {
    changes.pdrep_change = true;
    changes.rep_change = true;
  }
  if (
    old_event.event_rep_id !== new_event.event_rep_id ||
    old_event.sales_rep_id !== new_event.sales_rep_id ||
    old_event.project_manager_id !== new_event.project_manager_id
  ) {
    changes.rep_change = true;
  }
  if (old_event.bureauID !== new_event.bureauID) {
    changes.bureauID_change = true;
    changes.rep_change = true;
  }

  if (
    parseFloat(_.get(old_event, ["Evaluation", "score"], 0)) -
      parseFloat(_.get(new_event, ["Evaluation", "score"], 0)) !==
    0
  ) {
    if (
      parseFloat(_.get(new_event, ["Evaluation", "score"], 0)) < 4.2 &&
      parseFloat(_.get(new_event, ["Evaluation", "score"], 0)) > 0
    ) {
      if (_.get(new_event, ["Evaluation", "service_recovery"]) !== "1") {
        changes.evaluation_score_changed = true;
      }
    }
  }

  changes.company_change =
    old_event.companyID !== new_event.companyID && old_event.companyID > 0;

  changes.royalty_dependant_item_changed = _.any(
    ["eventClass", "speechTitle", "deliveryMethod", "presentingproductid"],
    function (key) {
      if (old_event[key] === new_event[key]) {
        return false;
      }
      //this is to consider things like "" and null equal
      return (
        _.size(
          _.uniq(
            _.map([old_event[key], new_event[key]], function (e) {
              return !e ? "" : _.isString(e) ? e.trim() : e;
            })
          )
        ) > 1
      );
    }
  );

  //certain flags may trigger a new royalty
  changes.royalty_dependant_item_changed =
    changes.royalty_dependant_item_changed ||
    _.any(["coaching"], function (key) {
      return (
        old_event.flags_as_map[key].is_set !==
        new_event.flags_as_map[key].is_set
      );
    });

  // changes to the event, stagetime, venue, or services trigger a change to the relay
  changes.relay_changed = _.any(
    ["sids", "Stagetime", "Service", "Venue"],
    function (key) {
      if (old_event[key] === new_event[key]) {
        return false;
      }
      //this is to consider things like "" and null equal
      return (
        _.size(
          _.uniq(
            _.map([old_event[key], new_event[key]], function (e) {
              return !e ? "" : _.isString(e) ? e.trim() : e;
            })
          )
        ) > 1
      );
    }
  );

  return changes;
};

module.exports.init = function () {
  radio("start_EventPoller").subscribe(EventPoller.start);
  radio("stop_EventPoller").subscribe(EventPoller.stop);

  ServicesUtils.RadioAjax(
    "load_Event",
    function (event_id, success, failure) {
      if (!esUtils.isNumber(event_id) || event_id < 1) {
        failure("not a valid event id: " + event_id);
        return;
      }
      if (eventCache.read(event_id) !== null) {
        broadcastEvent(event_id);
        success(eventCache.read(event_id));
        return;
      }
      Balboa.api(
        "/event/read/" + event_id,
        {},
        function (data) {
          eventCache.save(
            event_id,
            esUtils.convertBalboa3EventToJSEvent(data.data.event)
          );
          broadcastEvent(event_id);
          success(eventCache.read(event_id));
        },
        function (data) {
          failure((data && data.message) || "unknown cause");
        }
      );
    },
    function (event_id) {
      return event_id;
    }
  );

  radio("reload_Event").subscribe(function (event_id) {
    event_id = esUtils.toInt(event_id);
    eventCache.save(event_id, null);
    radio("load_Event").broadcast(event_id);
  });

  radio("save_Event").subscribe(function (new_event) {
    let old_event = eventCache.read(new_event.eid);
    let changes = getEventChangeSummary(old_event, new_event);
    let old_eventrep_login = _.has(old_event, "pd_rep_id")
      ? old_event.pd_rep_id
      : undefined;

    let event = esUtils.convertJSEventToBalboa3Event(_.cloneDeep(new_event));
    if (event === null) {
      return;
    }
    if (changes.status_change) {
      radio("event_schedule_change").broadcast(new_event);
      if (!_.isEmpty(new_event.childevents)) {
        radio("event_offer_to_update_children_status").broadcast(new_event);
      }
    }
    if (changes.royalty_dependant_item_changed) {
      //TODO: this radio call triggers a dialog that reloads the event after the user submits, which
      // might happen prior to the /event/update call below finishing, causing the event to be saved with previous data
      // Ought to change it so the royalty change request rides along with /event/update instead of being a separate call
      radio("royalty_dependant_item_changed").broadcast(new_event);
    }

    if (changes.company_change) {
      radio("company_change").broadcast(new_event);
    }

    let is_new = event.eid < 1;
    Balboa.api(
      "/event/update/" + event.eid,
      {
        event_json: event,
      },
      function (data) {
        let event = esUtils.convertBalboa3EventToJSEvent(data.data.event);
        eventCache.save(event.eid, event);

        radio("save_Event_succeeded").broadcast(
          eventCache.read(event.eid),
          is_new,
          data.data.hasOwnProperty("displaymessage")
            ? data.data.displaymessage
            : null
        );
        broadcastEvent(event.eid);
        if (changes.status_changed_to_canceled) {
          radio("prompt_for_why_canceling_event").broadcast(
            eventCache.read(event.eid)
          );
        }
        if (changes.status_change) {
          radio("PromptApplyActionList_set_event_to_apply").broadcast(
            eventCache.read(event.eid)
          );
        }
        if (
          AuthedUserSession.is_st_family &&
          changes.pdrep_change &&
          old_eventrep_login
        ) {
          radio("EventRepChanged_show_modal").broadcast(
            eventCache.read(event.eid),
            old_eventrep_login
          );
        }
        if (changes.rep_change) {
          if (
            AuthedUserSession.is_st_family &&
            !_.isEmpty(
              _.filter(
                new_event.childevents,
                (c) => (_.get(c, ["flags"], 0) & 4) === 0
              )
            )
          ) {
            radio("event_offer_to_update_children_reps").broadcast(new_event);
          }
        }
        if (
          AuthedUserSession.is_st_family &&
          changes.evaluation_score_changed
        ) {
          radio("EvaluationScore_show_modal").broadcast(
            eventCache.read(event.eid)
          );
        }
        if (!AuthedUserSession.is_st_family && changes.relay_changed) {
          radio("PromptRelayChanged").broadcast(eventCache.read(event.eid));
        }
        if (
          AuthedUserSession.is_st_family &&
          changes.status_changed_to_confirmed
        ) {
          radio("PromptWhenEventConfirmed").broadcast(
            eventCache.read(event.eid)
          );
        }
      },
      function (data) {
        console.error("save_Event_failed", data);
        radio("save_Event_failed").broadcast(
          event,
          (data && data.message) || "unknown cause",
          is_new
        );
      }
    );
  });

  radio("Event_destroy").subscribe(
    _.debounce(function (event_id) {
      Balboa.api(
        "/event/destroy/" + event_id,
        {
          confirm: "y",
        },
        function (data) {
          radio("Event_destroyed").broadcast(event_id, data.message);
          eventCache.save(event_id, null);
        },
        function (data) {
          radio("Event_destroy_failed").broadcast(
            event_id,
            (data && data.message) || "unknown cause"
          );
          console.error(data);
        }
      );
    })
  );

  RadioService(
    "Event_notify_contact",
    function (
      { event_id, recipientemail, recipientname, messagetype },
      callback
    ) {
      Balboa.api(
        "/event/notifycontact/" + event_id,
        {
          recipientemail,
          recipientname,
          messagetype,
        },
        function (data) {
          callback(null, data.data.displaymessage);
        },
        function (data) {
          callback(
            "Failed to send invite: " +
              ((data && data.message) || "unknown cause")
          );
        }
      );
    }
  );

  ServicesUtils.RadioAjax(
    "copy_Event",
    function (event_id, target_sid, copylists, success, failure) {
      Balboa.api(
        "/event/copyevent/" + event_id,
        {
          target_sid: target_sid,
          copylists: !!copylists,
        },
        function (data) {
          success(event_id, data.event_id);
        },
        function (data) {
          failure(event_id, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  ServicesUtils.RadioAjax(
    "email_Event_to_coworkers",
    function (event_id, coworkers, subject, note, email, success, failure) {
      Balboa.api(
        "/event/emailtocoworkers/" + event_id,
        {
          coworkers: coworkers,
          subject: subject,
          note: note,
          email: email,
        },
        function (data) {
          success(event_id);
        },
        function (data) {
          failure(event_id, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  radio("StoredFile_remove").subscribe(function (
    eid,
    fileid,
    sids_to_apply_to
  ) {
    Balboa.api(
      "/event/storedfileremove/" + eid,
      {
        fileid: fileid,
        sids_to_apply_to: JSON.stringify(esUtils.cleanup_ids(sids_to_apply_to)),
      },
      function (data) {
        var storedfiles = data.data;
        var event = eventCache.read(eid);
        if (event !== null) {
          eventCache.extend(event.eid, {
            storedfiles: _.map(storedfiles, esUtils.StoredFile_Balboa3toJS),
          });
          broadcastEvent(event.eid);
        }
        if (eid < 1) {
          reloadDisplaylists();
        }
        radio("StoredFile_remove_succeeded").broadcast(
          eid,
          fileid,
          storedfiles
        );
      },
      function (data) {
        radio("StoredFile_remove_failed").broadcast(
          eid,
          fileid,
          (data && data.message) || "unknown cause"
        );
        console.error("StoredFile_remove", data);
      }
    );
  });

  radio("StoredFile_save").subscribe(function (
    eid,
    fileid,
    description,
    upload_File,
    sids_to_apply_to
  ) {
    var params = {
      fileid: fileid,
      description: description,
      sids_to_apply_to: JSON.stringify(esUtils.cleanup_ids(sids_to_apply_to)),
    };
    if (upload_File) {
      if (upload_File instanceof FileList) {
        for (var i = 0; i < upload_File.length; i++) {
          params[Constants.FileStore_UPLOAD_FILE_NAME + "_" + i] =
            upload_File[i];
        }
      } else {
        params[Constants.FileStore_UPLOAD_FILE_NAME] = upload_File;
      }
    }
    Balboa.api(
      "/event/storedfileupdate/" + eid,
      params,
      function (data) {
        var storedfiles = data.data;
        var event = eventCache.read(eid);
        if (event !== null) {
          eventCache.extend(event.eid, {
            storedfiles: _.map(storedfiles, esUtils.StoredFile_Balboa3toJS),
          });
          broadcastEvent(event.eid);
        }
        if (eid < 1) {
          reloadDisplaylists();
        }
        radio("StoredFile_save_succeeded").broadcast(eid, fileid, storedfiles);
      },
      function (data) {
        radio("StoredFile_save_failed").broadcast(
          eid,
          fileid,
          (data && data.message) || "unknown cause"
        );
        console.error("StoredFile_save", data);
      },
      function (percent) {
        radio("StoredFile_save_progress").broadcast(eid, fileid, percent);
      }
    );
  });

  ServicesUtils.RadioAjax(
    "MergeDocument",
    function (eid, template_id, success, failure) {
      Balboa.api(
        "/event/mergedocument/" + eid,
        {
          templateid: template_id,
        },
        function (data) {
          success(eid, template_id, {
            message: data.message,
            download_url: data.download_url,
          });
        },
        function (data) {
          failure(eid, template_id, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  RadioService("Event_change_parentID", function (params, callback) {
    Balboa.api(
      "/event/changeparentid/" + params.eid,
      {
        parentID: params.parentID,
      },
      function (data) {
        eventCache.save(
          params.eid,
          esUtils.convertBalboa3EventToJSEvent(data.data)
        );
        broadcastEvent(params.eid);
        callback(null, eventCache.read(params.eid));
      },
      function (data) {
        callback((data && data.message) || "unknown cause");
      }
    );
  });

  RadioService("Event_update_children_status", function (params, callback) {
    Balboa.api(
      "/event/updatechildrenstatus/" + params.eid,
      {
        status: params.status,
        applyactionlist: !!_.get(params, "applyactionlist", false),
      },
      function (data) {
        callback();
      },
      function (data) {
        callback((data && data.message) || "unknown cause");
      }
    );
  });

  RadioService("Event_update_children_reps", function (params, callback) {
    Balboa.api(
      "/event/updatechildrenreps/" + params.eid,
      {
        pd_rep_id: params.pd_rep_id,
        sales_rep_id: params.sales_rep_id,
        project_manager_id: params.project_manager_id,
      },
      function (data) {
        callback();
      },
      function (data) {
        callback((data && data.message) || "unknown cause");
      }
    );
  });

  RadioService("Event_my_events_on_date", function (params, callback) {
    Balboa.api(
      "/event/myeventsondate",
      {
        "yyyy-mm-dd": params["yyyy-mm-dd"],
        speaker_ids: params.speaker_ids,
      },
      function (data) {
        callback(null, data.data);
      },
      function (data) {
        callback(
          "Failed to fetch events on date: " +
            ((data && data.message) || "unknown cause")
        );
      }
    );
  });
};



// WEBPACK FOOTER //
// ./src/services/Event.js